import { JSX } from 'react';
import { TTabOption } from '@ui/tabs/tabs.types';
import AddOnsSettings from './content/add-ons/add-ons';
import { ESettingsTypes, ESettingsTypesLabels } from './settings.types';
import SiteSettings from './content/site/site';
import AdvancedSettings from './content/advanced/advanced';
import Integrations from './content/integrations/integrations';
import ModerationSettings from './content/moderation/moderation';
import RegistrationSettings from './content/registration/registration-settings';
import ContentSecurity from './content/security/content-security';
import ModerationEntryPoint from './content/moderation/moderation-entry-point';
import { ICONS } from '@ui/icons/types';
import { canGenerateContent, isAdminOrBuilder } from '@/types/permissions.types';

export type TSettingsTabOption = TTabOption & {
  /** rendered to the right of the "Project Settings • {label}" heading */
  headerAction?: JSX.Element;
};

export const SETTINGS_TABS: TSettingsTabOption[] = [
  {
    label: ESettingsTypesLabels.Site,
    icon: ICONS.SETTINGS_V2,
    value: ESettingsTypes.Site,
    content: <SiteSettings />,
    roles: isAdminOrBuilder,
  },
  {
    label: ESettingsTypesLabels.Registration,
    icon: ICONS.REGISTRATION,
    value: ESettingsTypes.Registration,
    content: <RegistrationSettings />,
    roles: isAdminOrBuilder,
  },
  {
    label: ESettingsTypesLabels.Advanced,
    icon: ICONS.TOOLS,
    value: ESettingsTypes.Advanced,
    content: <AdvancedSettings />,
    roles: isAdminOrBuilder,
  },
  {
    label: ESettingsTypesLabels.Moderation,
    icon: ICONS.MODERATOR_2,
    value: ESettingsTypes.Moderation,
    content: <ModerationSettings />,
    headerAction: <ModerationEntryPoint />,
    roles: canGenerateContent,
  },
  {
    label: ESettingsTypesLabels.Add_Ons,
    icon: ICONS.INTEGRATIONS_2,
    value: ESettingsTypes.Add_Ons,
    content: <AddOnsSettings />,
    roles: isAdminOrBuilder,
  },
  {
    label: ESettingsTypesLabels.Integrations,
    icon: ICONS.INTEGRATIONS,
    value: ESettingsTypes.Integrations,
    content: <Integrations />,
    roles: isAdminOrBuilder,
  },
  {
    label: ESettingsTypesLabels.Content_Security,
    icon: ICONS.SECURITY_SHIELD,
    value: ESettingsTypes.Content_Security,
    content: <ContentSecurity />,
    roles: isAdminOrBuilder,
  },
];
